module.exports = __webpack_public_path__ + "img/pocket_welt_width.ae8e0ccd.png";